var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3102_34468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 12.3776C13.3078 12.3776 12.6311 12.1723 12.0555 11.7877C11.4799 11.4032 11.0313 10.8565 10.7664 10.217C10.5015 9.57746 10.4322 8.87372 10.5673 8.19479C10.7023 7.51585 11.0356 6.89221 11.5251 6.40273C12.0146 5.91325 12.6383 5.5799 13.3172 5.44486C13.9961 5.30981 14.6999 5.37912 15.3394 5.64403C15.9789 5.90893 16.5256 6.35754 16.9101 6.93311C17.2947 7.50868 17.5 8.18537 17.5 8.8776C17.5 9.80586 17.1313 10.6961 16.4749 11.3525C15.8185 12.0089 14.9283 12.3776 14 12.3776ZM19.8333 17.0443C19.8333 16.116 19.4646 15.2258 18.8082 14.5694C18.1518 13.913 17.2616 13.5443 16.3333 13.5443H11.6667C10.7384 13.5443 9.84817 13.913 9.19179 14.5694C8.53542 15.2258 8.16667 16.116 8.16667 17.0443V19.3776H10.5V17.0443C10.5 16.7349 10.6229 16.4381 10.8417 16.2193C11.0605 16.0005 11.3572 15.8776 11.6667 15.8776H16.3333C16.6428 15.8776 16.9395 16.0005 17.1583 16.2193C17.3771 16.4381 17.5 16.7349 17.5 17.0443V19.3776H19.8333V17.0443ZM14.0105 28.3201C13.4349 28.3204 12.8793 28.1091 12.4495 27.7263L8.07683 24.0443H0V4.21094C0 3.28268 0.368749 2.39244 1.02513 1.73606C1.6815 1.07969 2.57174 0.710938 3.5 0.710938L24.5 0.710938C25.4283 0.710938 26.3185 1.07969 26.9749 1.73606C27.6313 2.39244 28 3.28268 28 4.21094V24.0443H20.0048L15.5167 27.7543C15.1009 28.121 14.5649 28.3223 14.0105 28.3201ZM2.33333 21.7109H8.92967L13.9755 25.9634L19.1672 21.7109H25.6667V4.21094C25.6667 3.90152 25.5438 3.60477 25.325 3.38598C25.1062 3.16719 24.8094 3.04427 24.5 3.04427H3.5C3.19058 3.04427 2.89383 3.16719 2.67504 3.38598C2.45625 3.60477 2.33333 3.90152 2.33333 4.21094V21.7109Z",
    fill: "#007AFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3102_34468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.710938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.700ebe6f3a1b0c538f36a524ee9bf545.svg";
export { ForwardRef as ReactComponent };